import { module } from 'angular';
import { PasswordInputComponent } from './gmc-password-input/gmc-password-input.component';
import { GmcPanelComponent } from './gmc-panel/gmc-panel.component';
import { GmcAvatarComponent } from './gmc-avatar/gmc-avatar.component';
import { GmcStatusInputComponent } from './gmc-status-input/gmc-status-input.component';
import{ GmcStatusInputNotlockComponent} from './gmc-status-input-notlock/gmc-status-input-notlock.component'
import { GmcInfoBlockComponent } from './gmc-info-block/gmc-info-block.component';
import { GmcChipsComponent } from './gmc-chips/gmc-chips.component';
import { TestModalComponent } from './test-modal/test-modal.component';
import { GmcAccordionModule } from './gmc-accordion/gmc-accordion.module';
import { GmcTabsModule } from './gmc-tabs/gmc-tabs.module';
import { GmcDropdownMenuModule } from './gmc-dropdown-menu/gmc-dropdown-menu.module';
import { PaymentIframeModalComponent } from './payment-iframe-modal/payment-iframe-modal.component';
import { GmcLocalSpinnerComponent } from './gmc-local-spinner/gmc-local-spinner.component';
import { LanguageLevelsFormComponent } from './language-levels-form/language-levels-form.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EssentialInfoFormComponent } from '../../components/essential-info-form/essential-info-form.component';
import { VideoIframeModalComponent } from './video-iframe-modal/video-iframe-modal.component';
import { GmcDatePickerModule } from './gmc-date-picker/gmc-date-picker.module';
import { GmcSwitchComponent } from './gmc-switch/gmc-switch.component';
import { DeleteAccountModule } from './delete-account/delete-account.module';
import { SocialFormComponent } from './social-form/social-form.component';
import { GmcSelectModule } from './gmc-select-2/gmc-select-2.module';
import { GmcSelect3Module } from './gmc-select-3/gmc-select-3.module';
import { UsersMilestoneProgressBarComponent } from './users-milestone-progress-bar/users-milestone-progress-bar.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { GmcCvFilterModule } from './gmc-cv-filter/gmc-cv-filter.module';
import { AttachmentUploadBtnModule } from '../../components/attachment-upload-btn/attachment-upload-btn.module';
import { GmcProgressBarComponent } from './gmc-progress-bar/gmc-progress-bar.component';
import { GmcPanelIconComponent } from './gmc-panel-icon/gmc-panel-icon.component';
import { GmcBannerComponent } from './gmc-banner/gmc-banner.component';
import { CropImageModalModule } from '../../components/modals/crop-image-modal/crop-image.modal.module';
import { GmcBannerEmpComponent } from './gmc-banner-emp/gmc-banner-emp.component';
import { GmcSwitchInnerComponent } from './gmc-switch-inner/gmc-switch-inner.component';
import { GmcSelect4Module } from './gmc-select-4/gmc-select-4.module';
import { GmcChips2Component } from './gmc-chips-2/gmc-chips-2.component';
import { GmcFromToPickerComponent } from './gmc-from-to-picker/gmc-from-to-picker.component';
import { GmcAirportComponent } from './gmc-airport/gmc-airport.component';

export const SharedComponentsModule = module('app.shared.components', [
  GmcAccordionModule.name,
  GmcTabsModule.name,
  GmcDropdownMenuModule.name,
  GmcDatePickerModule.name,
  DeleteAccountModule.name,
  GmcSelectModule.name,
  GmcSelect3Module.name,
  GmcSelect4Module.name,
  GmcCvFilterModule.name,
  AttachmentUploadBtnModule.name,
  CropImageModalModule
])
  .component('gmcFromToPicker', GmcFromToPickerComponent)
  .component('gmcPasswordInput', PasswordInputComponent)
  .component('gmcPanel', GmcPanelComponent)
  .component('gmcAvatar', GmcAvatarComponent)
  .component('gmcStatusInput', GmcStatusInputComponent)
  .component('gmcStatusInputNotlock', GmcStatusInputNotlockComponent)
  .component('gmcInfoBlock', GmcInfoBlockComponent)
  .component('gmcChips', GmcChipsComponent)
  .component('testModal', TestModalComponent)
  .component('gmcLocalSpinner', GmcLocalSpinnerComponent)
  .component('paymentIframeModal', PaymentIframeModalComponent)
  .component('languageLevelsForm', LanguageLevelsFormComponent)
  .component('changePassword', ChangePasswordComponent)
  .component('essentialInfo', EssentialInfoFormComponent)
  .component('videoIframeModal', VideoIframeModalComponent)
  .component('gmcSwitch', GmcSwitchComponent)
  .component('socialForm', SocialFormComponent)
  .component('usersMilestoneProgressBar', UsersMilestoneProgressBarComponent)
  .component('infoModal', InfoModalComponent)
  .component('gmcProgressBar', GmcProgressBarComponent)
  .component('gmcPanelIcon', GmcPanelIconComponent)
  .component('gmcBanner', GmcBannerComponent)
  .component('gmcBannerEmp', GmcBannerEmpComponent)
  .component('gmcAirport', GmcAirportComponent)
  .component('gmcSwitchInner', GmcSwitchInnerComponent)
  .component('gmcChips2', GmcChips2Component);



// WEBPACK FOOTER //
// ./app/shared/components/shared-components.module.ts